import { render, staticRenderFns } from "./Remember.vue?vue&type=template&id=4f2f29c8"
import script from "./Remember.vue?vue&type=script&lang=js"
export * from "./Remember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports